import type {
  PlaceStateBookingPanel,
  PlaceBookingPanel,
} from '@web-platform/shared-universal-types/src/redux/state/shared/flightBookingPanel/entities/placesBookingPanel';
import type { EntityId } from '@web-platform/shared-universal-types-utils/src/utils';

export const getByEntityId = (
  state: PlaceStateBookingPanel,
  entityId: EntityId,
): PlaceBookingPanel => state.byEntityId[entityId];

export const allByEntityId = (state: PlaceStateBookingPanel): Record<EntityId, PlaceBookingPanel> =>
  state.byEntityId;
